import { Pipe } from '@angular/core';
import type { PipeTransform } from '@angular/core';

@Pipe({
  name: 'tdWbAnalyticsKey'
})
export class AnalyticsEventKeyPipe implements PipeTransform {
  transform(prefix: string, value: string): string {
    let result = value;
    const indices = this.findDelimiters(value, '_');
    indices.push(0);
    indices.forEach((idx: number)=>{
      const actualIdx = idx === 0 ? 0 : idx + 1;
      result = this.capitalizeCharAt(result, actualIdx);
    });
    return prefix + result;
  }

  private capitalizeCharAt(value: string, idx: number): string {
    const replacement = value.charAt(idx).toUpperCase();

    if (idx === 0){
      return replacement + value.substring(1);
    } else {
      return value.substring(0, idx) + replacement + value.substring(idx + 1);
    }
  }

  private findDelimiters(str: string, delimeter: string): Array<number> {
    const indices = [];
    let idx = 0;
    while (idx < str.length){
      if (str.charAt(idx) === delimeter){
        indices.push(idx);
      }
      idx++;
    }
    return indices;
  }
}
